import { ArrowRight } from "lucide-react";

const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSc1jDfsBoci1VGf3xZniRsxsgCGi8PBPO5lXzw6hm8XIAdBuA/viewform?usp=send_form";

export default function RegistrationSection() {
  return (
    <section
      id="register"
      data-testid="registration-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto text-center">
          <span className="text-sm font-semibold tracking-wider uppercase text-orange-600 font-body">
            Join Us
          </span>
          <h2
            data-testid="registration-title"
            className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-zinc-900 tracking-tight leading-tight mt-4"
          >
            Apply for the Upcoming Cohort
          </h2>
          <p className="font-body text-base md:text-lg text-zinc-500 leading-relaxed mt-5 max-w-xl mx-auto">
            Fill out the application form with your details — Name, Class,
            Target Year, City, Parent Contact Number, and WhatsApp Number.
          </p>

          <div className="mt-10">
            <a
              href={GOOGLE_FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="registration-submit-btn"
              className="btn-lift inline-flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-700 text-white font-medium px-10 py-4 rounded-full transition-all text-base"
            >
              Submit Application
              <ArrowRight size={18} strokeWidth={1.5} />
            </a>
          </div>

          <p
            data-testid="registration-note"
            className="font-body text-sm text-zinc-400 mt-6"
          >
            Seats are limited to maintain batch quality.
          </p>
        </div>
      </div>
    </section>
  );
}
